import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import type { GetV1OrganizationsByOrganizationIdResponse } from "../../client";
import { getV1OrganizationsByOrganizationIdOptions } from "../../client/@tanstack/react-query.gen";
import { jsonParse } from "../utils/parse";

export const getOrganizationOptions = (id: string) => {
  const base = getV1OrganizationsByOrganizationIdOptions({
    path: { organizationID: id },
  });
  return queryOptions({
    ...base,
    queryFn: async (ctx) => {
      const label = `[QUERY] getOrganization id=${id}`;
      console.time(label);
      const result = await base.queryFn!(ctx);
      console.timeEnd(label);
      return result;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
    select: (data) => {
      // Currently, getV1OrganizationsByOrganizationIdOptions returns as string
      // so we need to parse it
      if (data)
        return jsonParse<GetV1OrganizationsByOrganizationIdResponse>(data);
      return data;
    },
  });
};

export const useGetOrganization = (id: string) => {
  return useSuspenseQuery(getOrganizationOptions(id));
};
